import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindAll } from '@bibliocommons/utils-react';
import { SecondaryGhostButton } from '@bibliocommons/base-buttons';
import { FLAG_TYPES } from 'app/constants/FlagsConstants';
import { Warning } from '@bibliocommons/base-icons';
import { ugcFlagShape } from '@bibliocommons/bc-prop-types';

import './ContentWarningPanel.scss';

export default class ContentWarningPanel extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  toggleSpoilers(value) {
    this.props.contentWarningActions.toggleSpoilers(value);
  }

  toggleOffensiveContent(value) {
    this.props.contentWarningActions.toggleOffensiveContent(value);
  }

  render() {
    const { flaggedContentVisibility, flags } = this.props;
    const spoilersPresent = flags.some(flag => flag.get('flaggedTypes').includes(FLAG_TYPES.SPOILER));
    const offensiveContentPresent = flags.some(flag => flag.get('flaggedTypes').includes(FLAG_TYPES.OFFENSIVE));
    if (!spoilersPresent && !offensiveContentPresent) return null;

    return (
      <div className="cp-content-warning-panel">
        <div className="icon-wrapper">
          <Warning />
        </div>
        <div className="body">
          <span className="title">
            <FormattedMessage id="content_warning_title" />
          </span>
          <FormattedMessage id="content_warning_text" />
          <br />
          {spoilersPresent &&
            (flaggedContentVisibility.get('spoilersVisible') ? (
              <SecondaryGhostButton handleClick={() => this.toggleSpoilers(false)} size="small" dataKey="hide-spoilers">
                <FormattedMessage id="hide_spoilers" />
              </SecondaryGhostButton>
            ) : (
              <SecondaryGhostButton handleClick={() => this.toggleSpoilers(true)} size="small" dataKey="show-spoilers">
                <FormattedMessage id="show_spoilers" />
              </SecondaryGhostButton>
            ))}
          {offensiveContentPresent &&
            (flaggedContentVisibility.get('offensiveContentVisible') ? (
              <SecondaryGhostButton
                handleClick={() => this.toggleOffensiveContent(false)}
                size="small"
                dataKey="hide-offensive-content"
              >
                <FormattedMessage id="hide_offensive_content" />
              </SecondaryGhostButton>
            ) : (
              <SecondaryGhostButton
                handleClick={() => this.toggleOffensiveContent(true)}
                size="small"
                dataKey="show-offensive-content"
              >
                <FormattedMessage id="show_offensive_content" />
              </SecondaryGhostButton>
            ))}
        </div>
      </div>
    );
  }
}

ContentWarningPanel.propTypes = {
  flags: ImmutablePropTypes.mapOf(ugcFlagShape),
  flaggedContentVisibility: ImmutablePropTypes.mapOf(PropTypes.bool),
  contentWarningActions: PropTypes.objectOf(PropTypes.func).isRequired
};
